<template>
    <div>
        <van-sticky>
            <van-search autofocus :clearable="false" v-model="keywords"
                        placeholder="通过手机号码/姓名查找客户"/>
        </van-sticky>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="get_data"
            >
                <div v-for="item in ExternalUserFollowInfo_BuyStau.StdQuery" :key="item" @click="openDetail(item)">
                    <van-cell is-link

                              :title="item.ExternalUserId">
                        <template #title>
                            <div class="title">
                                <van-image
                                        round
                                        width="20px"
                                        height="20px"
                                        fit="cover"
                                        :src="item.Avatar"
                                />
                                {{ item.Name }}
                            </div>
                            <div v-if="item.ExpectAmount" style="padding-top: 12px">预计成交:{{ item.ExpectAmount }}
                            </div>
                        </template>
                        <template>
                            {{ item.StatusMemo }}-{{ item.CreateDate }}
                        </template>
                    </van-cell>
                    <div class="status_memo">{{ item.LastMemo }}
                        <div class="font12" style="padding-top: 12px">{{ item.LastMemoDate }}</div>
                    </div>
                </div>
            </van-list>

        </van-pull-refresh>
    </div>
</template>
<script>
export default {
    name: "WorkUserSearch",
    components: {},
    data() {
        return {
            refreshing: false,
            start: 0,
            length: 10,
            loading: false,
            finished: false,
            keywords: "",
            ExternalUserFollowInfo_BuyStau: {
                StdQuery: []
            }
        }
    },
    watch: {
        "keywords": {
            handler(val) {
                let _this = this
                if (this.setTimeFlag != null) {
                    clearTimeout(this.setTimeFlag);
                }
                this.setTimeFlag = setTimeout(() => {
                    _this.ExternalUserFollowInfo_BuyStau.StdQuery = []
                    // 清空列表数据
                    _this.start = 0
                    _this.length = 10
                    _this.finished = false;
                    // 重新加载数据
                    // 将 loading 设置为 true，表示处于加载状态
                    _this.loading = true;
                    _this.get_data();
                }, 700);
            }
        },
    },
    created() {
    },
    methods: {
        openDetail(item) {
            this.$router.push({
                path: "/work/detail",
                query: {
                    ExternalUserId: item.ExternalUserId
                }
            });
        },
        async get_data() {
            let _data = await this.$frame.getStdQueryData("ExternalUserFollowInfo_Search", {
                Name: this.keywords,
                start: this.start,
                length: this.length
            })
            this.ExternalUserFollowInfo_BuyStau.StdQuery = this.ExternalUserFollowInfo_BuyStau.StdQuery.concat(_data.StdQuery)
            if (_data.StdQuery.length == 10) {
                this.start += 10
            } else if (_data.StdQuery.length < 10) {
                this.finished = true
            }
            if (this.refreshing) {
                this.refreshing = false;
            }
            // 加载状态结束
            this.loading = false;
        },
        onRefresh() {
            this.ExternalUserFollowInfo_BuyStau.StdQuery = []
            // 清空列表数据
            this.start = 0
            this.length = 10
            this.keyword = ""
            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.get_data();
        },
    }
}
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;

  ::v-deep {
    .van-image {
      margin-right: 12px;
    }
  }
}

.status_memo {
  background-color: #fff;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: $base-box-shadow;
}
</style>
